import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["question", "answer"];

  connect() {
    // Optionally, collapse all answers on connect
    this.answerTargets.forEach((el) => {
      el.hidden = true;
    });
    this.questionTargets.forEach((btn) => {
      btn.setAttribute("aria-expanded", "false");
    });
  }

  toggle(event) {
    const btn = event.currentTarget;
    const idx = btn.dataset.faqIndex;
    const answer = this.answerTargets[idx];
    const expanded = btn.getAttribute("aria-expanded") === "true";
    btn.setAttribute("aria-expanded", !expanded);
    answer.hidden = expanded;

    // Animate caret icon (rotate 180deg for up)
    const caret = btn.querySelector('.faq-caret');
    if (caret) {
      caret.classList.toggle('rotated', !expanded);
    }
  }
}